export default {
  nav: {
    home: "Startseite",
    spreadsheet: "Tabelle",
    categories: "Kategorien",
    guides: "Ratgeber",
    comparisons: "Vergleiche",
    safety: "Sicherheit",
    faq: "FAQ",
    search: "Suche",
    language: "Sprache",
    cta: "Tabelle Erkunden",
  },
  categories: {
    shoes: "Schuhe",
    hoodies: "Hoodies / Pullover",
    tshirts: "T-Shirts",
    jackets: "Jacken",
    pants: "Hosen / Shorts",
    headwear: "Kopfbedeckungen",
    sets: "Sets",
    underwear: "Unterwäsche",
    jersey: "Trikots",
    accessories: "Accessoires",
    bags: "Taschen",
    belts: "Gürtel",
    perfumes: "Parfums",
    other: "Sonstiges",
  },
  hero: {
    eyebrow: "DAS ALLCHINABUY FORSCHUNGSZENTRUM",
    h1: "AllChinaBuy Spreadsheet — Produkte, Verkäufer und Kaufressourcen Schneller Finden",
    subheadline: "Erkunden Sie die AllChinaBuy-Tabelle, Produkttforschungsratgeber, Verkäuferressourcen, QC-Tipps, Versandinformationen und die neuesten Kaufressourcen — alles an einem Ort organisiert.",
    ctaPrimary: "AllChinaBuy Spreadsheet Erkunden",
    ctaSecondary: "Kaufratgeber Durchsuchen",
    trust: "Aktualisierte Ressourcen • Produkttforschung • QC-Ratgeber • Versandinformationen • Sicherheitsressourcen",
    searchPlaceholder: "Suche nach Produkten, Verkäufern, Versandratgebern oder AllChinaBuy-Ressourcen...",
  },
  valueProp: {
    h2: "Alles, Was Sie Brauchen, um AllChinaBuy Produkte zu Erforschen",
    copy: "Produkte zu finden ist nur der erste Schritt. Unser AllChinaBuy-Ressourcencenter hilft Ihnen, Produkte zu erforschen, Optionen zu vergleichen, QC-Informationen zu verstehen, Versandmethoden zu erkunden und besser informierte Kaufentscheidungen zu treffen.",
    cta: "Alle Ressourcen Erkunden",
    cards: {
      spreadsheet: {
        title: "AllChinaBuy Spreadsheet",
        desc: "Finden Sie organisierte Produkt- und Forschungsressourcen.",
      },
      research: {
        title: "Produkttforschung",
        desc: "Lernen Sie, wie Sie Produkte vor der Bestellung bewerten.",
      },
      sellers: {
        title: "Verkäufer-Ratgeber",
        desc: "Verstehen Sie Verkäuferinformationen und Produktauswahl.",
      },
      qc: {
        title: "QC Ressourcen",
        desc: "Lernen Sie, worauf Sie bei der Überprüfung von Qualitätskontrollinformationen achten sollten.",
      },
      shipping: {
        title: "Versand-Ratgeber",
        desc: "Verstehen Sie Versandoptionen, Kosten und wichtige Überlegungen.",
      },
      safety: {
        title: "Sicherheitszentrum",
        desc: "Lernen Sie praktische Wege, um häufige Kauf- und Sicherheitsrisiken zu reduzieren.",
      },
    },
  },
  spreadsheetPreview: {
    h2: "AllChinaBuy Spreadsheet",
    copy: "Die AllChinaBuy-Tabelle ist die zentrale Ressource für die Produkttentdeckung, die Organisation von Forschung und das Finden nützlicher Kaufinformationen. Nutzen Sie sie als Ausgangspunkt und erkunden Sie dann unsere detaillierten Ratgeber, bevor Sie Kaufentscheidungen treffen.",
    cta: "AllChinaBuy Spreadsheet Öffnen",
    columns: {
      product: "Produkt",
      category: "Kategorie",
      seller: "Verkäufer",
      status: "Forschungsstatus",
      qc: "QC Ressource",
      guide: "Ratgeber",
      updated: "Aktualisiert",
    },
  },
  trust: {
    h2: "Warum Dieses AllChinaBuy Ressourcencenter Nutzen?",
    cards: {
      organized: {
        title: "Organisierte Forschung",
        desc: "Ressourcen sind nach Produkt, Kategorie, Verkäufer, QC, Versand und Kaufabsicht gruppiert.",
      },
      comparisons: {
        title: "Nützliche Vergleiche",
        desc: "Klare Tabellen helfen Benutzern, die Unterschiede zwischen Optionen zu verstehen.",
      },
      updated: {
        title: "Aktualisierter Inhalt",
        desc: "Veröffentlichungs- und Aktualisierungsdaten anzeigen.",
      },
      safetyFirst: {
        title: "Sicherheit Zuerst",
        desc: "Bietet praktische Informationen zu Produkttforschung, Zahlungen, Konten und Versand.",
      },
      multilingual: {
        title: "Mehrsprachig",
        desc: "Versionen auf Englisch, Französisch, Dänisch und Deutsch.",
      },
      independent: {
        title: "Unabhängige Ressource",
        desc: "Offenlegung der Beziehung der Website zur Hauptwebsite, wo zutreffend.",
      },
    },
  },
  comparison: {
    h2: "AllChinaBuy Ressourcen auf einen Blick",
    cta: "Das Vollständige Ressourcencenter Erkunden",
    headers: {
      resource: "Ressource",
      bestFor: "Am Besten Für",
      info: "Information",
    },
    rows: {
      spreadsheet: { name: "AllChinaBuy Spreadsheet", bestFor: "Produkttentdeckung", info: "Produkte & Forschung" },
      productGuides: { name: "Produktt-Ratgeber", bestFor: "Produkttforschung", info: "Kaufüberlegungen" },
      qcGuides: { name: "QC-Ratgeber", bestFor: "Qualitätskontrolle", info: "QC-Prinzipien" },
      shippingGuides: { name: "Versand-Ratgeber", bestFor: "Versandforschung", info: "Methoden & Faktoren" },
      warehouseGuide: { name: "Lager-Ratgeber", bestFor: "Lagerinformationen", info: "Lagerung & Verarbeitung" },
      safetyGuide: { name: "Sicherheits-Ratgeber", bestFor: "Risikobewusstsein", info: "Sicherheit & Schutz" },
    },
  },
  reviewSection: {
    h2: "AllChinaBuy Bewertung: Was Sollten Käufer Wissen?",
    copy: "Bevor Sie eine Kaufplattform nutzen, ist es wichtig zu verstehen, wie Produkttforschung, Bestellung, QC, Lagerabwicklung und Versand funktionieren. Unser AllChinaBuy-Bewertungsinhalt konzentriert sich auf praktische Informationen statt auf unbelegte Behauptungen.",
    cta: "Die AllChinaBuy Bewertung Lesen",
  },
  shippingSection: {
    h2: "AllChinaBuy Versandkosten & Versand-Ratgeber",
    copy: "Versandkosten können je nach Ziel, Paketgröße, Gewicht, Versandmethode und anderen Faktoren variieren. Lernen Sie, wie Versand funktioniert, was die Endkosten beeinflussen kann und wie Sie verfügbare Optionen vergleichen.",
    cta: "AllChinaBuy Versand-Ratgeber Ansehen",
  },
  couponSection: {
    h2: "AllChinaBuy Gutschein & Rabattcode",
    copy: "Suchen Sie nach AllChinaBuy-Gutscheinen oder Rabattcodes? Überprüfen Sie unsere neuesten Gutschein- und Promotionsressourcen vor der Bestellung. Überprüfen Sie immer, ob ein Angebot aktuell, gültig und bestimmten Bedingungen unterliegt.",
    cta: "Gutscheine & Rabatte Prüfen",
  },
  warehouseSection: {
    h2: "AllChinaBuy Lager-Ratgeber",
    copy: "Verstehen Sie, wie Lagerung, Produktinspektion, Abwicklung und Versandvorbereitung in den Kaufprozess passen.",
    cta: "Lager-Ratgeber Erkunden",
  },
  safetySection: {
    h2: "Ist AllChinaBuy Legitim & Sicher?",
    copy: "Die Recherche zur Legitimität einer Plattform sollte mehr umfassen als eine einfache Ja- oder Nein-Antwort. Lernen Sie, was zu überprüfen ist, wie Sie Ihr Konto und Zahlungsinformationen schützen, wie Sie Produktinformationen bewerten und welche Risiken Sie vor der Bestellung berücksichtigen sollten.",
    cta: "Den AllChinaBuy Sicherheits-Ratgeber Lesen",
  },
  finalCta: {
    h2: "Starten Sie mit dem AllChinaBuy Spreadsheet",
    copy: "Produkte erforschen. Optionen vergleichen. QC und Versand verstehen. Besser informierte Kaufentscheidungen treffen.",
    ctaPrimary: "AllChinaBuy Spreadsheet Erkunden",
    ctaSecondary: "Den Einsteiger-Ratgeber Lesen",
  },
  categoryButtons: {
    h2: "AllChinaBuy Kategorien Durchsuchen",
    copy: "Springen Sie direkt zu Ihrer Lieblingsproduktkategorie im Hauptgeschäft.",
  },
  productShowcase: {
    h2: "Ausgewählte Produkte",
    copy: "Durchsuchen Sie kuratierte Produkte aus der AllChinaBuy-Tabelle. Klicken Sie auf einen Artikel, um Details anzuzeigen und im Hauptgeschäft zu kaufen.",
    viewAll: "Alle {{category}} Ansehen",
  },
  productCard: {
    buyNow: "Jetzt Kaufen",
  },
  productDetail: {
    notFound: "Produkt Nicht Gefunden",
    notFoundDesc: "Das gesuchte Produkt existiert nicht oder wurde entfernt.",
    backHome: "Zurück zur Startseite",
    verified: "Verifizierte Produktliste",
    qcAvailable: "QC-Fotos Verfügbar",
    shippingGlobal: "Weltweite Versandoptionen",
    buyNow: "Jetzt Kaufen — Zum Geschäft",
    viewCategory: "Alle in Kategorie Ansehen",
    redirectNotice: "Sie werden zum offiziellen Geschäft weitergeleitet, um Ihren Kauf abzuschließen.",
    relatedTitle: "Das Könnte Ihnen Auch Gefallen",
  },
  ctaButtons: {
    allchinabuy: "AllChinaBuy Spreadsheet",
    buyNow: "Jetzt Kaufen",
  },
  footer: {
    tagline: "AllChinaBuy Spreadsheet — Ihr Forschungszentrum für intelligentere Kaufentscheidungen.",
    links: {
      about: "Über Uns",
      privacy: "Datenschutz",
      terms: "Bedingungen",
      contact: "Kontakt",
    },
    copyright: "© 2026 AllChinaBuy Spreadsheet. Alle Rechte vorbehalten.",
  },
  lang: {
    en: "English",
    fr: "Français",
    da: "Dansk",
    de: "Deutsch",
  },
  article: {
    readMore: "Vollständigen Ratgeber Lesen",
    relatedArticles: "Verwandte Artikel",
  },
  faq: {
    h2: "Häufig Gestellte Fragen",
    q1: "Was ist das AllChinaBuy Spreadsheet?",
    a1: "Das AllChinaBuy-Spreadsheet ist eine organisierte Ressource, die Käufern hilft, Produkte zu entdecken, Verkäufer zu erforschen, Optionen zu vergleichen und informierte Kaufentscheidungen zu treffen.",
    q2: "Wie verwende ich das AllChinaBuy Spreadsheet?",
    a2: "Beginnen Sie mit dem Durchsuchen der Kategorien, die Ihrem Interesse entsprechen. Verwenden Sie die Suchfunktion, um bestimmte Produkte oder Verkäufer zu finden. Überprüfen Sie die QC- und Versandratgeber, bevor Sie Bestellungen aufgeben.",
    q3: "Ist AllChinaBuy sicher zu verwenden?",
    a3: "Sicherheit hängt von Ihren Forschungspraktiken ab. Unsere Ratgeber decken Kontoschutz, Zahlungssicherheit, Produktevaluierung und Risikominderungsstrategien ab.",
    q4: "Wie hoch sind die AllChinaBuy-Versandkosten?",
    a4: "Versandkosten variieren je nach Ziel, Paketgewicht, Abmessungen und gewählter Versandmethode. Sehen Sie sich unseren Versandratgeber für detaillierte Aufschlüsselungen an.",
    q5: "Bietet AllChinaBuy Gutscheine oder Rabatte an?",
    a5: "Gutscheine und Aktionen können zeitweise verfügbar sein. Überprüfen Sie immer aktuelle Angebote und lesen Sie die Bedingungen, bevor Sie einen Rabattcode anwenden.",
  },
};